export const CAREER_ADD = "CAREER_ADD";

export const ADMIN_ERROR_STATE = "ADMIN_ERROR_STATE";
